export default {
  props: {
    size: {
      type: String,
      default: undefined
    },
    variant: {
      type: String,
      default: undefined
    }
  }
}
